import { render, staticRenderFns } from "./OrderCardCollectionLogDialog.vue?vue&type=template&id=10bc3f56&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./OrderCardCollectionLogDialog.vue?vue&type=script&lang=js&"
export * from "./OrderCardCollectionLogDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardCollectionLogDialog.vue?vue&type=style&index=0&id=10bc3f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc3f56",
  null
  
)

export default component.exports